import gql from 'graphql-tag';

export default gql`
    query GetJobFiltersList {
        getJobFiltersList {
            statuses {
                id
                name
            }
            regions {
                id
                name
            }
        }
    }
`;
